import React from 'react'

const Acknowledgement = () => (
  <div className="acknowledgement">
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <div className="footer__section-container">
            <div className="flag-aboriginal">
            </div>
            <h3><a className="utility acknowledgement" href="https://www.vu.edu.au/about-vu/university-profile/moondani-balluk">Acknowledgement of country</a></h3>
            <p>Victoria University acknowledges, recognises and respects the Ancestors, Elders and families of the Bunurong/Boonwurrung, Wadawurrung and Wurundjeri/Woiwurrung of the Kulin who are the traditional owners of University land in Victoria, the Gadigal and Guring-gai of the Eora Nation who are the traditional owners of University land in Sydney, and the Turrubal people living in Meanjin (Brisbane).</p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Acknowledgement
